<template>
  <div
    :class="[
      'game',
      'game-hole',
      (status !== undefined || showSolution) && 'game-finished',
    ]"
  >
    <Keypress
      key-event="keyup"
      @success="onKeyUp($event)"
      :prevent-default="false"
    />
    <h2>Gatið</h2>
    <div v-if="sentence" :title="sentence.icelandic">
      <div
        v-if="sentence.english"
        :title="sentence.english"
        class="sentence-en"
      >
        {{ sentence.english }}
      </div>
      <div v-if="sentence.french" :title="sentence.french" class="sentence-fr">
        {{ sentence.french }}
      </div>
      <div class="sentence-is">
        <div
          v-for="(greynir, idxWord) in sentence.greynir"
          :key="idxWord"
          :class="greynir.hide ? 'word-hole' : 'word-is'"
        >
          <div v-if="!greynir.hide">{{ greynir.text }}</div>
          <div
            v-else
            v-for="(letter, idxLetter) in letters"
            :key="`word-${idxLetter}`"
            :title="letter"
            :class="[
              letter !== ' ' ? 'letter' : 'blank',
              idxLetter === current && 'current',
              letter !== ' ' &&
                input[idxLetter] !== ' ' &&
                (letter === input[idxLetter] ? 'letter-ok' : 'letter-error'),
            ]"
            @click="onClick($event, index)"
          >
            {{ showSolution ? letter : input[idxLetter] }}
          </div>
        </div>
      </div>
    </div>
    <IcelandicCharacters v-on:is-char-event="onIsChar" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IcelandicCharacters from "@/components/IcelandicCharacters.vue";
import axios from "axios";

const constants = require("@/constants.js");

export default {
  name: "GameHole",
  components: {
    IcelandicCharacters,
    Keypress: () => import("vue-keypress"),
  },
  data() {
    const emptyWord = {};
    emptyWord[this.gameSrcLang] = "";
    emptyWord[this.gameTargetLang] = "";
    return {
      emptyWord,
      current: 0,
      letters: [],
      input: [],
      status: undefined,
      showSolution: false,
      errors: 0,
      sentence: undefined,
    };
  },
  computed: {
    ...mapGetters([
      "gameSrcLang",
      "gameTargetLang",
      "gameAllowedErrors",
      "gameSentence",
    ]),
    // sentence: function () {
    //   return this.gameSentence;
    // },
  },
  mounted() {
    // console.log(
    //   `mounted ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.initGame();
  },
  created() {
    // console.log(
    //   `created ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.$store.subscribe((mutation, state) => {
      if (["CATEGORY_SELECTED", "NEW_GAME"].includes(mutation.type)) {
        this.initGame();
      }
    });
  },
  methods: {
    onClick(e, index) {
      console.log("onClick");
    },
    onKeyPress(e) {
      //
      // TODO https://github.com/lupas/vue-keypress
      //
      if (e) {
        console.log(`onKeyPress charCode: ${e.charCode} key: ${e.key}`);
      }
    },
    onKeyUp(e) {
      if (this.showSolution) return;

      if (e.event.altKey) return;
      //
      // TODO https://github.com/lupas/vue-keypress
      //
      // console.log(`onKeyUp keyCode: ${e.event.keyCode} key: ${e.event.key}`);
      // 37 left, 39 right
      if (e.event.keyCode == 37) {
        if (this.current > 0) {
          this.current--;
          if (this.letters[this.current] === " " && this.current > 0) {
            this.current--;
          }
        }
      } else if (e.event.keyCode == 39) {
        if (this.current < this.letters.length - 1) {
          this.current++;
          if (
            this.letters[this.current] === " " &&
            this.current < this.letters.length - 1
          ) {
            this.current++;
          }
        }
      } else {
        let ch = e.event.key.toLowerCase();
        if (
          constants.ALPHABET.includes(ch) ||
          constants.PUNCTUATIONS.includes(ch)
        ) {
          this.inputChar(ch);
        }
      }
    },
    onIsChar(ch) {
      this.inputChar(ch);
    },
    inputChar(ch) {
      if (this.showSolution) return;

      this.input[this.current] = ch;
      this.input = this.input.slice(0);

      if (this.current < this.letters.length - 1) {
        if (this.letters[this.current] === this.input[this.current]) {
          this.current++;
          if (
            this.letters[this.current] === " " &&
            this.current < this.letters.length - 1
          ) {
            this.current++;
          }
        }
      }

      let same = true;
      let filled = 0;
      for (let ii = 0; ii < this.letters.length; ii++) {
        if (
          this.letters[ii] === " " ||
          (this.letters[ii] !== " " && this.input[ii] !== " ")
        ) {
          filled++;
        }
        if (this.letters[ii] !== this.input[ii]) {
          same = false;
        }
      }
      if (filled == this.letters.length) {
        this.setGameStatus(same);
      } else {
        this.setGameStatus(undefined);
      }
    },
    async initGame() {
      const sentence = await axios.get(
        "http://localhost:82/groopy/sentences?anonymize"
      );
      this.sentence = sentence.data[0];

      console.log(
        `GameHole initGame: ${this.sentence ? this.sentence.icelandic : "null"}`
      );

      this.showSolution = false;
      this.current = 0;
      this.letters = [];
      this.input = [];
      if (this.sentence) {
        let greynir = this.sentence.greynir.find((g) => g.hide);
        for (const ch of greynir.text) {
          this.letters.push(ch);
          if (constants.ALPHABET.includes(ch)) {
            this.input.push(" ");
          } else {
            this.input.push(ch);
          }
        }
      }
      this.setGameStatus(undefined);
      this.errors = 0;
    },
    setGameStatus(status) {
      if (status === false) {
        this.errors++;
        if (this.errors < this.gameAllowedErrors) return;
      }
      this.status = status;
      this.$emit("gameStatus", this.status);
    },
    solution() {
      this.showSolution = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";

.sentence-en, .sentence-fr {
  font-style: italic;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 48px 32px;
  display: inline-block;
  padding-left: 60px;
}
.sentence-en {
  background-image: url("../assets/flags/flag_UK.jpg");
}
.sentence-fr {
  background-image: url("../assets/flags/flag_FR.jpg");
}
.sentence-is {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 48px 32px;
  background-image: url("../assets/flags/flag_IS.jpg");
  padding-left: 60px;
}
.word-is {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.word-hole {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.word-hole:not(:first-child) {
  margin-left: 0.5rem;
}
.word-hole:not(:last-child) {
  margin-right: 0.5rem;
}
@keyframes blink {
  50% {
    border-bottom-color: transparent;
  }
}
.letter {
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  height: 2.5rem;
  width: 1.5rem;
  line-height: 2rem;
  border-bottom: 6px solid #555;

  &.current {
    animation: blink 0.5s step-end infinite alternate;
  }
}
.game-finished .letter {
  border-bottom-color: orange;
}
.game.status-ok .letter.current {
  animation: none;
}
.letter-ok {
  border-bottom-color: green;
}
.letter-error {
  border-bottom-color: red;
}
.blank {
  width: 1rem;
}
</style>
